import { h } from "preact";

function Explain() {
  return (
    <div class="container mx-auto">
      <h2 class="h2">Wind Rose Diagram Explanation</h2>
      <h3 class="h3 text-gray-900">
        What's a wind rose chart?
      </h3>
      <p class="prose lg:prose-xl xl:prose-xl">
        A wind rose chart graphically presents wind direction and velocity and the
        frequency of the varying wind directions over a period of time at a
        specific location, revealing the dominant wind patterns.
      </p>
      <p class="prose lg:prose-xl xl:prose-xl">
        Despite their name, wind rose charts can be used to display any
        (time-)varying directional data, like orientations of geological layers
        or ocean current directions.
      </p>
      <h2 class="h2">What this site good for?</h2>
      <p class="prose lg:prose-xl xl:prose-xl">
        WindRose.xyz lets you create beautiful wind rose charts intuitively.
        It does not provide the functionality to process data to make a windrose
        chart however.
      </p>

      <p class="prose lg:prose-xl xl:prose-xl">
        The directions and bins need to be known before values can be entered
      </p>

      <h3 class="h3 text-gray-900">Sources &amp; Links</h3>
      <ul>
        <li>
          <a href="https://www.climate.gov/maps-data/dataset/wind-roses-charts-and-tabular-data">
            Climate.gov
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Explain;
